/**
 * Helper function written in response to regression found in Voiceover + Safari to minimize user
 * styling changes due to the underlying DOM change to resolve this a11y issue.
 * See https://indeed.atlassian.net/browse/IFL-2709 and https://bugs.webkit.org/show_bug.cgi?id=282105
 * for more information
 * @param val sx prop whom's keys are to be recursively rewritten
 * @returns sx prop with key values transformed if finding 'details'
 */
const sanitizeSx = (val, from, to) => {
  if (typeof val === "object" && val !== null && from.length > 0 && to.length > 0) {
    return Object.keys(val).reduce((acc, key) => {
      let curKey = key;
      while (curKey.indexOf(from) !== -1) {
        curKey = curKey.replace(from, to);
      }

      // this typescript override is because we know that it's going to always be
      // an object with a `key` that can be either a 'string' or a child CSS selector
      // e.g. sx={{'>summary': {'>div>':{other selectors}}}}
      // @ts-ignore
      const oldKeyValue = val[key];
      const sanitized = sanitizeSx(oldKeyValue, from, to);
      // @ts-ignore
      acc[curKey] = sanitized; // updates current key with transformed nested selectors

      return acc;
    }, {});
  }
  return val;
};

export { sanitizeSx };
